import { gql } from '@apollo/client';

export const DELETE_PROGRAMME = gql`
  mutation deleteProgramme($id: ID!) {
    programme: deleteProgramme(id: $id) {
      id
      name
    }
  }
`;
